import {useLocation} from 'react-router-dom';
import {parse} from 'querystring';

export function useQuery() {
  const {search} = useLocation();
  return parse(search.replace('?', ''));
}
